<ng-container>
    <app-grid-client-side
        #categoriesGridComponent
        [headerCheckboxSelection]="true"
        (areRowsSelected)="handleSelectionChange($event)"
        (rowClicked)="rowClicked($event)"
        [hidden]="!gridPath"
        [tableData]="tableData[0]"
        [fixedButtons]="fixedButtons"
        (deleteChange)="deleteCategories($event)"
        (gridReadyEmitter)="onGridReady()"
        (filterChangedEmitter)="onFilterChangedEmitter($event)"
        [exportFormatterOptions]="exportFormatterOptions"
        (clickableAction)="actions($event)"
        feature="categories"
    ></app-grid-client-side>
</ng-container>